/*
 * Noibu A/B test: "Collection tiles above best sellers on home"
 * Flag key: 4565-collection-tiles-above-best-sellers-on-home
 * Variations: original (control) | category-tiles-under-hero
 *
 * What this does (homepage only; loaded from layout/theme.liquid when template.name == 'index'):
 *   - original:                  nothing changes.
 *   - category-tiles-under-hero: moves the existing category tiles section (templates/index.json
 *                                key "section-2", type image-link-blocks) to sit directly under the
 *                                hero slideshow ("section-1"), above Best sellers ("section-5").
 *   The section itself is not edited or duplicated; only its position on the page changes.
 *
 * Timing: Noibu's script loads after the page's load event and fetches its flags about a second
 * later, so this waits for that answer (up to 15 s after load) instead of giving up early.
 * Returning visitors get the version Noibu gave their browser last time right away (stored in
 * localStorage), so the tiles don't jump on every page view; Noibu's answer still decides.
 *
 * Deploy order: merge this, QA both variations, THEN start the test in Noibu.
 * When the test is stopped: remove this file and its script tag in layout/theme.liquid, and if
 * the variation won, move "section-2" under the hero in the theme editor.
 */
(function () {
  'use strict';

  var FLAG_KEY = '4565-collection-tiles-above-best-sellers-on-home';
  var CONTROL = 'original';
  var VARIANT = 'category-tiles-under-hero';
  var CHALLENGER = [VARIANT, 'Category tiles under hero']; // key or display name
  var GIVE_UP_AFTER_LOAD_MS = 15000;
  var POLL_MS = 150;
  var HINT_KEY = 'nb_ab_home_tiles_arm';

  function safe(fn, fallback) { try { return fn(); } catch (e) { return fallback; } }

  // Homepage sections are rendered as <div id="shopify-section-template--<id>__<key>">.
  // Match on the key suffix so this keeps working on any copy of the theme.
  function section(key) {
    return document.querySelector('#main .shopify-section[id^="shopify-section-template--"][id$="__' + key + '"]');
  }

  // Returns the arm once Noibu has loaded its flags, or null while it has not.
  // Before the flags load, getStringDetails answers with reason ERROR / errorCode FLAG_NOT_FOUND
  // and the default value, which must not be mistaken for a real "original" assignment.
  function resolvedArm() {
    var client = safe(function () { return window.NoibuFeatureFlag && window.NoibuFeatureFlag.getClient(); }, null);
    if (!client) return null;
    var d = safe(function () { return client.getStringDetails(FLAG_KEY, CONTROL); }, null);
    if (!d || d.errorCode || d.reason === 'ERROR') return null;
    var v = d.variant || d.variation || d.value || CONTROL;
    return CHALLENGER.indexOf(v) !== -1 ? VARIANT : CONTROL;
  }

  var moved = false;
  var originalNext = null;

  function moveTiles() {
    if (moved) return true;
    var tiles = section('section-2');
    var hero = section('section-1');
    var bestSellers = section('section-5');
    if (!tiles || !(hero || bestSellers)) return false;
    // Sanity check: only move the section if it is still the category tiles block.
    if (tiles.querySelectorAll('a[href*="/collections/"]').length < 3) return false;
    originalNext = tiles.nextElementSibling;
    if (hero) {
      if (hero.nextElementSibling !== tiles) hero.parentNode.insertBefore(tiles, hero.nextElementSibling);
    } else {
      bestSellers.parentNode.insertBefore(tiles, bestSellers);
    }
    moved = true;
    return true;
  }

  function restoreTiles() {
    if (!moved) return;
    var tiles = section('section-2');
    if (tiles && originalNext && originalNext.parentNode) originalNext.parentNode.insertBefore(tiles, originalNext);
    moved = false;
  }

  function apply(arm) {
    safe(function () { localStorage.setItem(HINT_KEY, arm); });
    var rendered = arm;
    if (arm === VARIANT) {
      if (!moveTiles()) rendered = CONTROL + ' (tiles section not found)';
    } else {
      restoreTiles();
    }
    // Second attribute so "assigned" and "actually rendered" can be compared in Noibu.
    safe(function () { window.NOIBUJS.addCustomAttribute('ab_rendered_' + FLAG_KEY, rendered); });
  }

  // Noibu never answered (blocked by the browser, or the test has ended): forget the stored
  // version so the next page view shows the original page.
  function giveUp() {
    safe(function () { localStorage.removeItem(HINT_KEY); });
  }

  // Returning visitor already assigned to the variation: show it right away.
  if (safe(function () { return localStorage.getItem(HINT_KEY); }, null) === VARIANT) moveTiles();

  var loadedAt = document.readyState === 'complete' ? Date.now() : null;
  if (!loadedAt) window.addEventListener('load', function () { loadedAt = Date.now(); });

  (function poll() {
    var arm = resolvedArm();
    if (arm) return apply(arm);
    if (loadedAt && Date.now() - loadedAt >= GIVE_UP_AFTER_LOAD_MS) return giveUp();
    setTimeout(poll, POLL_MS);
  })();
})();
